var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.71,
    height: 17.01,
    viewBox: "0 0 21.71 17.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1779",
    "data-name": "Rectangle 1779",
    width: 21.71,
    height: 17.01,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5786",
    "data-name": "Group 5786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5785",
    "data-name": "Group 5785",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8182",
    "data-name": "Path 8182",
    d: "M15.48,13.64c-1.23-1.53-4.38-2.4-6.59-2.59-.32-.03-.62-.04-.89-.04s-.56.01-.87.04C4.33,11.29,0,12.61,0,15.01v1a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1v-1a2.166,2.166,0,0,0-.52-1.37M10.98,2.35a3.692,3.692,0,0,0-1.33-.97A3.8,3.8,0,0,0,8,1.01a4,4,0,0,0-4,4A3.953,3.953,0,0,0,6.42,8.67,3.8,3.8,0,0,0,8,9.01h.03a4,4,0,0,0,3.97-4,3.95,3.95,0,0,0-1.02-2.66",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8183",
    "data-name": "Path 8183",
    d: "M17.38,9.65,14.41,7.89V4.4a.542.542,0,0,0-.55-.55h-.05a.54.54,0,0,0-.55.54V8.03a.772.772,0,0,0,.37.66l3.19,1.91a.551.551,0,0,0,.56-.95m0,0L14.41,7.89V4.4a.542.542,0,0,0-.55-.55h-.05a.54.54,0,0,0-.55.54V8.03a.772.772,0,0,0,.37.66l3.19,1.91a.551.551,0,0,0,.56-.95M14.03,0a.01.01,0,0,0-.01.01A7.677,7.677,0,0,0,6.35,7.69a6.37,6.37,0,0,0,.07.98A3.8,3.8,0,0,0,8,9.01h.03a5.744,5.744,0,0,1-.15-1.32,6.133,6.133,0,0,1,3.1-5.34,6.068,6.068,0,0,1,3.05-.81,6.136,6.136,0,0,1,1.45,12.1,5.393,5.393,0,0,1-1.45.19,6.113,6.113,0,0,1-5.14-2.78c-.32-.03-.62-.04-.89-.04s-.56.01-.87.04a7.654,7.654,0,0,0,6.9,4.32A7.55,7.55,0,0,0,16,15.11,7.684,7.684,0,0,0,14.03,0m-.17,3.85h-.05a.54.54,0,0,0-.55.54V8.03a.772.772,0,0,0,.37.66l3.19,1.91a.551.551,0,0,0,.56-.95L14.41,7.89V4.4a.542.542,0,0,0-.55-.55",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenagementIcon);
export default __webpack_public_path__ + "static/media/menagement_icon.08548f0e42e8664cc6f0e7f1bb9ea73d.svg";
export { ForwardRef as ReactComponent };